import { isPxplay } from 'src/conponents/Shared/Header';
import { create } from 'zustand';

const searchParams = new URLSearchParams(window.location.search);

const sortByKey = 'sort_by';
const sortDirectionKey = 'sort_direction';

const useStore = create((set) => ({
  sortBy: searchParams.get(sortByKey) ?? 'popular',
  setSortBy: (value) => set(() => ({ sortBy: value })),
  sortDirection:
    searchParams.get(sortDirectionKey) ?? isPxplay ? 'asc' : 'desc',
  setSortDirection: (value) => set(() => ({ sortDirection: value })),
}));

const useSort = () => {
  const { sortBy, sortDirection, setSortBy, setSortDirection } = useStore();
  return {
    sortBy,
    sortDirection,
    setSortBy,
    setSortDirection,
    sortByKey,
    sortDirectionKey,
  };
};

export default useSort;
